import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { UserMinus, ArrowLeft, Printer } from "lucide-react";
import CommonDateRangePicker from "../../../Common/CommonDateRangePicker/CommonDateRangePicker";
import { combineAttendance } from "./attendanceUtils";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";

const HRMSEarlyGoing = () => {
  const { state } = useLocation();
  const employees = state?.employees || [];
  const logs = state?.logs || [];
  const rosters = state?.rosters || {};
  const rangeFromParent = state?.range || { startDate: "", endDate: "" };

  const [range, setRange] = useState(rangeFromParent);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!employees || employees.length === 0) return;
    if (!range.startDate || !range.endDate) {
      setData([]);
      return;
    }

    const allDates = [];
    const start = new Date(range.startDate);
    const end = new Date(range.endDate);
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      allDates.push(d.toISOString().split("T")[0]);
    }

    const all = [];
    allDates.forEach((date) => {
      const daily = combineAttendance(date, employees, logs, rosters);
      all.push(
        ...daily.filter((d) => d.status && d.status.includes("Left Early"))
      );
    });

    setData(all);
  }, [range, employees, logs, rosters]);

  const handleDownload = () => {
    if (data.length === 0)
      return Swal.fire("No data", "No early going records", "warning");
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Early_Goers");
    XLSX.writeFile(
      wb,
      `Early_Going_${range.startDate}_to_${range.endDate}.xlsx`
    );
  };

  if (!state) {
    return (
      <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <div className="text-center py-5">
          <h5>
            Please open this report from the <strong>HRMS Reports</strong> page.
          </h5>
          <Link to="/hrms-reports" className="btn btn-primary mt-3">
            Go to Reports
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row">
        <div className="col-12">
          <div className="hrms-early-going-cont">
            <div className="d-flex flex-column flex-lg-row row-gap-3 justify-content-between align-items-center">
              <div className="d-flex gap-3 align-items-center">
                <UserMinus size={35} stroke="#ca8a04" />
                <div className="d-flex flex-column">
                  <h4 className="fw-semibold m-0">Early Going Report</h4>
                  <span className="text-muted">
                    Detailed list of all early departures for the selected date
                    range.
                  </span>
                </div>
              </div>
              <Link
                to="/hrms-reports"
                className="d-flex align-items-center gap-2 btn hrms-reports-back-btn"
              >
                <ArrowLeft size={20} />
                Back to Reports
              </Link>
            </div>

            <div className="row mt-3 row-gap-2">
              <div className="col-lg-10 col-sm-12 col-12">
                <CommonDateRangePicker
                  label="Date Range"
                  value={range}
                  onChange={setRange}
                />
              </div>
              <div className="col-lg-2 col-sm-12 col-12 d-flex align-items-end">
                <button
                  className="btn hrms-report-btn w-100"
                  onClick={handleDownload}
                >
                  <Printer size={18} stroke="#fff" />
                  <span className="text-light">Download Report</span>
                </button>
              </div>
            </div>
          </div>

          <div className="hrms-leave-report-cont mt-4">
            <div className="d-flex flex-column row-gap-1">
              <h4 className="fw-semibold m-0">
                Early Departures ({data.length})
              </h4>
              <span className="text-muted">
                Displaying records from{" "}
                {range.startDate && range.endDate
                  ? `${range.startDate} to ${range.endDate}`
                  : "No range selected yet"}
              </span>
            </div>

            <div className="table-responsive">
              <table className="table align-middle mb-0 table-hover mt-4">
                <thead>
                  <tr className="text-muted small border-top">
                    <th>Date</th>
                    <th>Employee</th>
                    <th>Emp. Code</th>
                    <th>Department</th>
                    <th>Punch In Time</th>
                    <th>Early By</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((record, i) => (
                      <tr key={i}>
                        <td>{record.date}</td>
                        <td>{record.name || "-"}</td>
                        <td>{record.employee_code || "-"}</td>
                        <td>{record.department || "-"}</td>
                        <td>{record.entry || "-"}</td>
                        <td>{record.status || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className="text-center py-3 text-muted">
                        {range.startDate && range.endDate
                          ? "No early departure records found for the selected date range."
                          : "Please select a date range."}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HRMSEarlyGoing;
